module.exports = __webpack_public_path__ + "static/media/IFU-20-002-Rev A.730455c6.pdf";